import React from 'react';
import '../App.css';
import MemberLogoConvergence from '../components/MemberLogoConvergence';
import { members } from '../data/members';

const Home = ({ onNavigate }) => {
  const goToAbout = () => onNavigate?.('about');
  const goToMembers = () => onNavigate?.('members', 'join-dingonet');
  const goToContact = () => onNavigate?.('contact', 'get-in-touch');
  return (
    <div className="App">
      <main className="hero">
        <div className="hero-background" aria-hidden="true">
          <div className="hero-background__kenburns" />
          <div className="hero-background__slideshow" />
        </div>
        <div className="hero-overlay" />
        <div className="hero-content">
          <div className="hero-shell">
            <div className="hero-badges">
              <span className="hero-badge">National NGO Coordination Platform</span>
              <span className="hero-badge">Disaster Risk Reduction</span>
            </div>
            <p className="hero-kicker">Welcome to</p>
            <h1 className="hero-title">
              Disaster Management Non-government Organizations Network Tanzania
              <span className="hero-acronym"> (DINGONET)</span>
            </h1>
            <p className="hero-subtitle">
              Strengthening coordination for disaster preparedness, emergency response, and community resilience in
              Tanzania through collaboration, shared learning, and collective action.
            </p>

            <div className="hero-buttons">
              <button type="button" className="btn btn-primary" onClick={goToAbout}>
                Learn More
              </button>
              <button type="button" className="btn btn-secondary" onClick={goToMembers}>
                Become a Member
              </button>
              <button type="button" className="btn btn-ghost" onClick={goToContact}>
                Contact Us
              </button>
            </div>

            <div className="hero-stats">
              <div className="hero-stat">
                <span className="hero-stat-value">100+</span>
                <span className="hero-stat-label">Member Organizations</span>
              </div>
              <div className="hero-stat">
                <span className="hero-stat-value">25+</span>
                <span className="hero-stat-label">Regions Reached</span>
              </div>
              <div className="hero-stat">
                <span className="hero-stat-value">24/7</span>
                <span className="hero-stat-label">Response Coordination</span>
              </div>
            </div>
          </div>
        </div>
      </main>

      <section className="page-section page-section--light">
        <div className="section-inner">
          <h2 className="section-title">About DINGONET</h2>
          <p className="section-text">
            DINGONET is a nationally registered coordination platform bringing together NGOs engaged in disaster
            management and humanitarian action in Tanzania. The network promotes collaboration, information sharing,
            and coordinated responses to disasters affecting vulnerable communities.
          </p>
        </div>
      </section>

      <section className="page-section">
        <div className="section-inner">
          <h2 className="section-title">Key Focus Areas</h2>
          <div className="cards-grid">
            <div className="info-card">
              <div className="info-icon">🛡️</div>
              <h3>Prevention and Mitigation</h3>
            </div>
            <div className="info-card">
              <div className="info-icon">⛑️</div>
              <h3>Disaster preparedness</h3>
            </div>
            <div className="info-card">
              <div className="info-icon">🚑</div>
              <h3>Emergency response coordination</h3>
            </div>
            <div className="info-card">
              <div className="info-icon">📋</div>
              <h3>Joint assessments</h3>
            </div>
            <div className="info-card">
              <div className="info-icon">📚</div>
              <h3>Capacity building</h3>
            </div>
            <div className="info-card">
              <div className="info-icon">🔍</div>
              <h3>Research &amp; learning</h3>
            </div>
            <div className="info-card">
              <div className="info-icon">📢</div>
              <h3>Policy advocacy</h3>
            </div>
          </div>
        </div>
      </section>

      <section className="page-section page-section--light">
        <div className="section-inner">
          <h2 className="section-title">Latest Activities &amp; News</h2>
          <ul className="activities-list">
            <li>World Humanitarian Day 2025 – Dodoma</li>
            <li>Flood Response – Kibiti &amp; Rufiji</li>
            <li>Kariakoo Building Collapse Response</li>
          </ul>
        </div>
      </section>

      <section className="page-section">
        <div className="section-inner">
          <h2 className="section-title">Members &amp; Partners</h2>
          <p className="section-text">
            Member organizations unite under DINGONET to coordinate disaster preparedness, response, and resilience
            across Tanzania.
          </p>
          <MemberLogoConvergence members={members} className="mt-6" />
        </div>
      </section>

      <section className="page-section page-section--cta">
        <div className="section-inner section-inner--center">
          <h2 className="section-title">Be part of the network</h2>
          <p className="section-text">
            Join DINGONET to strengthen disaster risk reduction, preparedness, and response for communities across
            Tanzania.
          </p>
          <div className="hero-buttons">
            <button type="button" className="btn btn-primary" onClick={goToContact}>
              Join the Network
            </button>
            <button type="button" className="btn btn-secondary" onClick={goToContact}>
              Partner with Us
            </button>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Home;
